import { render, staticRenderFns } from "./KHtml.vue?vue&type=template&id=242e265c"
import script from "./KHtml.vue?vue&type=script&lang=js"
export * from "./KHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports